<template>
  <div :class="mapClass" ref="map">
    <template v-if="canShowMap">
      <slot :leaflet="leaflet" :map="map" />
    </template>
  </div>
</template>
<script>
import "leaflet/dist/leaflet.css";
import Leaflet from "leaflet";

export default {
  name: "LeafletMapLoader",
  props: {
    mapConfig: Object,
    mapClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      leaflet: null,
      map: null,
      tileLayer: null,
    };
  },
  mounted() {
    this.leaflet = Leaflet;
    this.initMap();
    this.$once("hook:beforeDestroy", () => {
      this.map.remove();
    });
  },
  computed: {
    canShowMap() {
      return Boolean(this.leaflet) && Boolean(this.map);
    },
  },
  methods: {
    initMap() {
      this.map = this.makeMap(this.mapConfig);
      //TODO Debug only
      ////////////////////////////////////////////////////////////////////
      this.map.on("zoomend", function () {
        if (!this.options || !this.options.crs) return;
        //var scale = getScale(this);
        //var equatorialScale = getScale(this, true);
        //console.info('scale=' + scale + '\nequatorialScale=' + equatorialScale + '\ncenter=' + this._lastCenter.lat + ' ' + this._lastCenter.lng);

        //function getScale(map, equatorial) {
        //	if (!map.options.crs._scales)
        //		return 40075000 * Math.cos(equatorial ? 0 : map.getCenter().lat * (Math.PI / 180)) / Math.pow(2, (map.getZoom() + 8)) * 3780;

        //	return Math.round(3571.428571428572 / map.options.crs._scales[map.getZoom()]);
        //}
      });
      ////////////////////////////////////////////////////////////////////
    },
    makeMap(mapConfig) {
      const map = this.leaflet.map(this.$refs.map, {
        zoomAnimationThreshold: 1,
        zoomControl: false,
        maxZoom: 19,
      });

      const maxBounds = convertToLatLngBounds(
        this.leaflet,
        mapConfig.mapBounds.minX,
        mapConfig.mapBounds.minY,
        mapConfig.mapBounds.maxX,
        mapConfig.mapBounds.maxY
      );

      map.fitBounds(maxBounds); //приближаемся до максимальных границ
      //map.setMinZoom(map.getZoom());//и фиксируем мастштаб

      //const enlargedMaxBounds = maxBounds.pad(1);
      //map.setMaxBounds(enlargedMaxBounds);
      if (mapConfig.initialBounds) {
        const initialBounds = convertToLatLngBounds(
          this.leaflet,
          mapConfig.initialBounds.minX,
          mapConfig.initialBounds.minY,
          mapConfig.initialBounds.maxX,
          mapConfig.initialBounds.maxY
        );
        map.fitBounds(initialBounds);
      }

      this.leaflet.DomUtil.removeClass(map._container, "leaflet-grab");
      map.attributionControl.setPrefix("Leaflet");

      return map;
    },
  },
};

const convertToLatLngBounds = function (leaflet, minX, minY, maxX, maxY) {
  const minLatLng = leaflet.latLng(minY, minX);
  const maxLatLng = leaflet.latLng(maxY, maxX);
  return leaflet.latLngBounds(minLatLng, maxLatLng);
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
